"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _uaoJs = require("uao-js");

var decode = function decode(data, charset) {
  var str = '';

  switch (charset) {
    case 'utf8':
    case 'utf-8':
      str = Buffer.from(data).toString('utf8');
      break;

    case 'big5':
      str = (0, _uaoJs.decodeSync)(String.fromCharCode.apply(String, (0, _toConsumableArray2["default"])(data)));
      break;

    default:
      throw new TypeError("Unknown charset: ".concat(charset));
  }

  return str;
};

var _default = decode;
exports["default"] = _default;